<template>
  <div class="wd-box">
  	<div class="wd-box-container" ref="listContainer" @scroll="handleScroll">
  		<div class="wd-user" v-if="data">
  			<div class="wd-user-left">
  				<img class="wd-user-img" :src="$store.state.userInfo.headPortrait" alt="" />
  				<div class="wd-user-content">
  					<span class="wd-user-content-span">{{$store.state.userInfo.nickName}}</span>
  					<span class="wd-user-content-span1">ID {{data.recodeCode}}</span>
  					<div class="wd-user-count">
  						<span class="wd-user-count-item" @click="handleShowGuanzhu(0)">{{$t('all.guanzhong')}}： {{data.followCount || 0}}</span>
  						<span class="wd-user-count-item" @click="handleShowGuanzhu(1)">{{$t('all.fensi')}}： {{data.vermicelliCount || 0}}</span>
  					</div>
  				</div>
  				<div class="wd-user-edit" @click="handleShowXgzl">
  					<img src="../../../assets/image/xiugaiziliao@2x.png" alt="" />
  					<span>{{$t('all.xiugaiziliao')}}</span>
  				</div>
  			</div>
			<div class="zhibozhongxin" @click="handleGoZhibozhongxin">{{$t('all.zhibozhongxin')}}</div>
  		</div>
		<div class="wd-zican">
			<div class="wd-zican-title">
				<span class="wd-zican-title-span">{{$t('all.zongzichanguzhi')}}</span>
				<!-- <span class="wd-zican-title-span1">{{$t('all.liushuijilu')}}</span> -->
			</div>
			<div class="wd-zican-box" @click="handleGoWallet">
			<!-- <div class="wd-zican-box"> -->
				<div class="wd-zican-box-num">{{userWalletInfo?userWalletInfo.valuationAmount:0}} {{userWalletInfo.toName}}</div>
				<div class="wd-zican-box-right">
					<div class="wd-zican-box-right-item" v-for="(item,index) in userWalletInfo.walletList" @click.stop="handleGoLiushui(item)">
						<img v-if="item.currencyLogo" class="wd-zican-box-right-item-logo" :src="item.currencyLogo" alt="" />
						<div class="wd-zican-box-right-item-text">
							<span class="wd-zican-box-right-item-span">{{item.currencyName}}</span>
							<span class="wd-zican-box-right-item-span1">{{$t('all.keyong')}} {{item.sumAvailableAmount}} {{$t('all.dongjie')}} {{item.sumFreezeAmount}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="wd-num">
			<div class="wd-chongbi">
				<div class="wd-chongbi-top">
					<div class="wd-chongbi-top-left">{{$t('all.chongbi')}}</div>
					<div class="wd-chongbi-top-right">
						<div class="wd-chongbi-top-right-item" v-for="(item,index) in cbList">
							<span :class="index===cbListIndex?'wd-chongbi-top-right-item-span':'wd-chongbi-top-right-item-span1'" @click="cbListIndex = index">{{item}}</span>
							<span class="wd-chongbi-top-right-item-xian" v-if="index == cbListIndex"></span>
						</div>
					</div>
				</div>
				<div class="wd-chongbi-content">
					<img src="../../../assets/image/ewm.png" alt="" />
					<div class="wd-chongbi-content-xian"></div>
					<div class="wd-chongbi-content-right">
						<div class="wd-chongbi-content-right-item">
							<span class="wd-chongbi-content-right-item-span">{{$t('all.wangluo')}}</span>
							<span class="wd-chongbi-content-right-item-span1">NB Chain</span>
						</div>
						<div class="wd-chongbi-content-right-item">
							<span class="wd-chongbi-content-right-item-span">{{$t('all.dizhi')}}</span>
							<span class="wd-chongbi-content-right-item-span1">0x82...8F91</span>
						</div>
					</div>
				</div>
			</div>
			<div class="wd-tibi">
				<div class="wd-chongbi-top">
					<div class="wd-chongbi-top-left">{{$t('all.tibi')}}</div>
					<div class="wd-chongbi-top-right">
						<div class="wd-chongbi-top-right-item" v-for="(item,index) in tbList">
							<span :class="index===tbListIndex?'wd-chongbi-top-right-item-span':'wd-chongbi-top-right-item-span1'" @click="tbListIndex = index">{{item}}</span>
							<span class="wd-chongbi-top-right-item-xian" v-if="index == tbListIndex"></span>
						</div>
					</div>
				</div>
				<div class="wd-tibi-dizhi">
					<div class="wd-tibi-dizhi-item">
						<span class="wd-tibi-dizhi-item-span">{{$t('all.dizhi')}}</span>
						<div class="wd-tibi-dizhi-item-right">
						    <span class="wd-tibi-dizhi-item-span1">0x82...8F91</span>
						    <img src="../../../assets/image/xiayibu_14@2x.png" alt="" />	
						</div>
					</div>
					<div class="wd-tibi-dizhi-xian"></div>
					<div class="wd-tibi-dizhi-item">
						<span class="wd-tibi-dizhi-item-span">{{$t('all.wangluo')}}</span>
						<span class="wd-tibi-dizhi-item-span1">NB Chain</span>
					</div>
				</div>
				<div class="wd-tibi-input-box">
					<div class="wd-tibi-input">
						<div class="wd-tibi-input-left">
							<span class="wd-tibi-input-left-span">{{$t('all.tibishuliang')}}</span>
							<span class="wd-tibi-input-left-span1">({{$t('all.zuixiaotibishuliang')}} 10.00 NB)</span>
						</div>
						<input class="wd-tibi-input-input" v-model="tibiAmount" type="text" placeholder="100.00" />
					</div>
				</div>
				<div class="wd-tibi-info">
					<div class="wd-tibi-info-item">
						<span class="wd-tibi-info-item-span">
							<span class="wd-tibi-info-item-span-span">{{$t('all.daozhangshisuan')}}</span>
							<span class="wd-tibi-info-item-span-span1">(1%{{$t('all.shouxufeibilv')}})</span>
						</span>
						<span class="wd-tibi-info-item-span1">{{$t('all.meirishenyueddu')}}: 900.00 NB</span>
					</div>
					<div class="wd-tibi-info-item">
						<span class="wd-tibi-info-item-span2">{{$t('all.shouxufei')}}: <span class="wd-tibi-info-item-highlight">1.00NB</span></span>
						<span class="wd-tibi-info-item-span2">{{$t('all.meiridaozhang')}}: <span class="wd-tibi-info-item-highlight1">99.00 NB</span></span>
					</div>
				</div>
			</div>
		</div> -->
		<duanyingyin ref="duanyingyin" v-if="appConfigInfo && appConfigInfo.videoStatus == 1"/>
  		<!-- <div class="wd-box-list">
  			<zbList v-for="(item,index) in list" :key="index" :data="item" :type="1"></zbList>
  		</div> -->
  	</div>
	<xiaofeimingxi ref="xfmx"/>
	<xiugaiziliao ref="xgzl"/>
	<guanzhu ref="gz" @change="getPresentUserInfo"/>
  </div>
</template>

<script>
import { getPresentUserInfo,getAppConfigInfo } from "@/api/user";
import { getUserWalletList } from "@/api/qianbao";
import xiaofeimingxi from "../../../components/xiaofeimingxi/xiaofeimingxi.vue"
import xiugaiziliao from "../../../components/xiugaiziliao/xiugaiziliao.vue"
import duanyingyin from "../../../components/duanyingyin/duanyingyin.vue"
import guanzhu from "../../../components/guanzhu/guanzhu.vue"
export default {
  components: {
	xiaofeimingxi,
	xiugaiziliao,
	duanyingyin,
	guanzhu
  },
  data() {
    return {
	  data:'',
	  cbList:['NB Chain','USDT','ETH'],
	  cbListIndex:0,
	  tbList:['NB Chain','USDT','ETH'],
	  tbListIndex:0,
	  tibiAmount:'',
	  userWalletInfo:'',
	  appConfigInfo:null
    };
  },
  mounted() {
	this.$store.commit('changeCount', 4);
	this.getPresentUserInfo()
	this.getUserWalletList()
	this.getAppConfigInfo()
  },
  methods: {
	async getPresentUserInfo(){
		const res = await getPresentUserInfo()
		this.data = res.data
	},
	async getUserWalletList(){
		const res = await getUserWalletList({queryValuationAmount:1})
		this.userWalletInfo = res.data
	},
	async getAppConfigInfo(){
		const res = await getAppConfigInfo()
		this.appConfigInfo = res.data
	},
	// 滚动事件处理函数 - 触发短影音加载更多
	handleScroll() {
	  const container = this.$refs.listContainer;
	  const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
	  if (isAtBottom && this.$refs.duanyingyin) {
		this.$refs.duanyingyin.loadMore();
	  }
	},
	//显示消费明细
	handleShowXfmx(){
		this.$refs.xfmx.showXfmx()
	},
	//修改资料
	handleShowXgzl(){
		this.$refs.xgzl.showModel()
	},
	//显示关注/粉丝弹框 tab: 0=关注中 1=粉丝
	handleShowGuanzhu(tab){
		this.$refs.gz.showGuanzhu(tab)
	},
	//跳转流水记录
	handleGoLiushui(data){
		this.$router.push({ path: '/liushuijilu',query: {
		  currencyId: data.currencyId,
		  unitText:data.unitText
		}});
	},
	//跳转我的钱包
	handleGoWallet(){
		this.$router.push('/wodeqianbao')
	},
	//跳转直播中心
	handleGoZhibozhongxin(){
		this.$router.push('/zhibozhongxin')
	},

  }
};
</script>
<style scoped lang="scss">
	@import "./wode.css";
</style>


// WEBPACK FOOTER //
// wode.vue?79e53ada